module.exports = __webpack_public_path__ + "static/media/info.0d4fc374.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/info.svg
// module id = 276
// module chunks = 0